import {
  getFiltersApi,
  getTabularDataApi,
  getAggregatedScoreApi,
  getTimelineApi,
  getTopNResultsApi,
  CFbarGraphData,
  CfTimelineGraphData,
} from 'api/analytics/feedback';

import { GroupByKeys, AggregatedScore } from './reviewHelper';

export const getFilters = () =>
  getFiltersApi().then((res) => ({
    ...res.entity,
    // cohorts: res.entity.cohort.map( ch => Cohort.fromJSON(ch)),
    cohorts: res.entity.cohort,
    groupByKeys: res.entity.groupByKeys.map((key) => GroupByKeys.fromJSON(key)),
    splitByKeys: res.entity.splitByKeys || [],
  }));

export const getAggregatedScore = ({ cohort, groupByKeys, splitByKeys, dateRange }) =>
  getAggregatedScoreApi({ cohort, groupByKeys, splitByKeys, dateRange }).then((res) =>
    res.entity.map((json) => AggregatedScore.fromJSON(json))
  );

export const getMaxGrowthCompetencies = ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderType = 'DESC',
  limit = 3,
  dateRange,
}) => {
  const orderBy = [
    {
      columnId: 'GOAL_PROGRESS_PERCENTAGE',
      orderType,
    },
  ];
  return getTopNResultsApi({ cohort, groupByKeys, splitByKeys, orderBy, limit, dateRange }).then((res) => res.entity);
};

export const getHighestStandingEmployees = ({
  cohort,
  groupByKeys,
  splitByKeys,
  orderType = 'DESC',
  limit = 3,
  dateRange,
  parentUuid,
}) => {
  const orderBy = [
    {
      columnId: 'GOAL_PROGRESS_PERCENTAGE',
      orderType,
    },
  ];
  return getTopNResultsApi({
    cohort,
    groupByKeys,
    splitByKeys,
    orderBy,
    limit,
    dateRange,
    parentUuid,
  }).then((res) => res.entity);
};

export const getTabularData = ({ cohort, groupByKeys, splitByKeys, parentUuid, orderBy, dateRange }) => {
  if (orderBy.columnId === null) orderBy = null;
  else orderBy = [orderBy];

  return getTabularDataApi({
    cohort,
    groupByKeys,
    splitByKeys,
    parentUuid,
    orderBy,
    dateRange,
  }).then((res) => res.entity);
};

export const getTimelineData = ({ cohort, groupByKeys, splitByKeys, parentUuid, dateRange }) =>
  getTimelineApi({ cohort, groupByKeys, splitByKeys, parentUuid, dateRange }).then((res) => res.entity);

export const getCFBargraphData = ({ cohort, groupByKeys, splitByKeys, dateRange }) =>
  CFbarGraphData({ cohort, groupByKeys, splitByKeys, dateRange }).then((res) => res.entity);

export const getCFTimelineGraphData = ({ cohort, groupByKeys, splitByKeys, dateRange }) =>
  CfTimelineGraphData({ cohort, groupByKeys, splitByKeys, dateRange }).then((res) => res.entity);
